import React from 'react'
import ContactComponent from '../../components/Contact/ContactComponent'

const Contact = () => {
  return (
    <div>
        <ContactComponent />
    </div>
  )
}

export default Contact